import { useEffect } from 'react';

import { IllustrationType } from '../types';

const DEPRECATED_ILLUSTRATIONS: Record<string, string> = {
  AUTODESK_WHITE: 'autodeskBlack',
};

export const useDeprecatedIllustration = (type: IllustrationType): void => {
  useEffect(() => {
    if (type in DEPRECATED_ILLUSTRATIONS) {
      console.warn(
        `Illustration type "${type}" is deprecated. Please update to type, "${DEPRECATED_ILLUSTRATIONS[type]}".`,
      );
    }
  }, [type]);
};
